var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-overlay',{attrs:{"show":_vm.isLoading,"rounded":"sm"}},[(_vm.publication)?_c('PageDetail',{attrs:{"publication":_vm.publication}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }